exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1200px){.modal-lg[data-v-f0726cb8]{width:1100px}}.modal-content[data-v-f0726cb8]{max-height:90vh;overflow:auto}", ""]);

// exports
